import { useCallback, useEffect, useRef, useState } from "react";
import { Button, Col, Container, Modal, Row, Spinner } from "react-bootstrap";
import { httpGet, httpGetBlobDownloadPdf, httpPost, httpPostMultiPart } from "../../http/request";
import { LiaBirthdayCakeSolid, LiaMoneyBillWaveSolid } from "react-icons/lia";
import { FaTreeCity, FaSchoolFlag, FaSchoolCircleExclamation, FaMoneyBillWave, FaTrashCan } from "react-icons/fa6";
import { FaRegIdCard, FaUserTag, FaHome, FaRegNewspaper, FaRegFilePdf, FaUniversity, FaCheckCircle, FaMapMarkedAlt, FaCut } from "react-icons/fa";
import { MdOutlinePhoneIphone, MdSchedule, MdEmail, MdClose } from "react-icons/md";
import { IoCheckmarkCircleOutline, IoCloseCircleSharp, IoMaleFemaleSharp, IoSchool } from "react-icons/io5";
import userImg from "../../assets/img/user.png";
import { LuUser } from "react-icons/lu";
import { RiContactsLine } from "react-icons/ri";
import { Link } from "react-router-dom";
import Select from "react-select";
import toast from "react-hot-toast";
import { useUsuario } from "../../context/UsuarioContext";
import { identificarCodigoPais } from "../../functions/utils";
import { BsBoxSeamFill, BsFillFilePersonFill, BsFillPersonVcardFill, BsPersonBoundingBox } from "react-icons/bs";
import { IoIosSchool } from "react-icons/io";
import { Cropper } from "react-cropper";
import "./imagecrop.css";
import "cropperjs/dist/cropper.css";
import { dataURLToFile } from "../../functions/imagenesUtils";
import MisCarrerasEstudiante from "../../componentes/MisCarrerasEstudiante";

const paises = [
  { nombre: "Bolivia", codigo: "+591", iso: "🇧🇴", value: "591" },
  { nombre: "Brasil", codigo: "+55", iso: "🇧🇷", value: "55" },
  { nombre: "Perú", codigo: "+51", iso: "🇵🇪", value: "51" },
];

const primerValor = (...valores) => valores.find((v) => v !== undefined && v !== null && v !== "" && v !== 0 && v !== "0");

const fechaVencimientoPostulacion = (postulante) => {
  if (postulante?.fec_vencimiento_format) {
    return postulante.fec_vencimiento_format;
  }
  if (!postulante?.fec_modificacion) {
    return "";
  }
  const fecha = new Date(postulante.fec_modificacion);
  if (Number.isNaN(fecha.getTime())) {
    return "";
  }
  fecha.setDate(fecha.getDate() + 7);
  return fecha.toLocaleDateString("es-BO", {
    day: "2-digit",
    month: "2-digit",
    year: "numeric",
  });
};

const esPostulacionAdjuntable = (postulante) => postulante?.isAdjuntable ?? postulante?.adjuntable ?? !postulante?.enProceso;

const tieneDatosPagoPostulacion = (postulante) =>
  Boolean(postulante?.costoAdmision) && Boolean(postulante?.idPerfilAdmision) && Boolean(postulante?.idConceptoAdmision);

const postulacionPuedeAdjuntar = (postulante) => esPostulacionAdjuntable(postulante) && tieneDatosPagoPostulacion(postulante);

const mensajeNoAdjuntable = (postulante) =>
  postulante?.msjNoAdjuntable ||
  (!tieneDatosPagoPostulacion(postulante)
    ? "No se puede generar el pago QR porque no se pudo determinar el costo o el perfil de admisión."
    : "No se puede adjuntar el pago de esta postulación. Verifique que esté vigente y que no tenga un pago en proceso.");

const Postulacion = () => {
  const { infoBasicData, setSpinnerLoad } = useUsuario();
  const [viewModalAddAjunto, setViewModalAddAdjunto] = useState(false);
  const [viewModalNuevo, setViewModalNuevo] = useState(false);
  const [viewModalCarrera, setViewModalCarrera] = useState({ show: false, data: {} });
  const [postulante, setPostulante] = useState({});
  const [registrarNuevo, setRegistrarNuevo] = useState(true);
  const [carrerasHabilitadas, setCarrerasHabilitadas] = useState([]);
  const [descargandoPdf, setDescargandoPdf] = useState(false);

  useEffect(() => {
    if (!(infoBasicData?.registrar ?? true)) {
      loadIniciados();
      loadCarrerasAdmision();
    }
  }, [infoBasicData]);

  const loadCarrerasAdmision = () => {
    httpGet("/api/v1/general/carrera_admision_habilitada").then((d) => {
      console.log(d);
      if (d) {
        setCarrerasHabilitadas(d);
      }
    });
  };

  const loadIniciados = () => {
    setSpinnerLoad(true);
    setViewModalNuevo(false);
    httpGet("/api/v1/postulante/buscarCi").then((d) => {
      console.log(d);
      if (d) {
        setRegistrarNuevo(false);
        setPostulante(d);
      } else {
        setRegistrarNuevo(true);
      }
      setSpinnerLoad(false);
    });
  };

  const descargarPdf = async () => {
    setDescargandoPdf(true);
    try {
      await httpGetBlobDownloadPdf("/api/v1/postulante/pdfPostulacion", "miPostulacion.pdf");
    } finally {
      setDescargandoPdf(false);
    }
  };

  return (
    <>
      <div className="content content-fixed  content-profile">
        <Container>
          <Row>
            <Col sm={12}>
              <div className="profile-sidebar pd-lg-r-25">
                <div className="row">
                  <div className="col-sm-auto">
                    <div className="avatar avatar-xxl avatar-online">
                      {<img src={postulante?.urlFoto ?? false ? postulante?.urlFoto ?? "" : userImg} className="rounded-circle" alt="" />}
                    </div>
                  </div>
                  {registrarNuevo ? (
                    <div className="col align-self-center">
                      <p className="m-0 mb-2">
                        <strong>No tiene ninguna postulación válida y/o vigente. </strong>
                        Para registrar una nueva postulación dale clik en el siguiente botón
                      </p>
                      <button className="btn btn-xs btn-primary flex-fill" onClick={() => setViewModalNuevo(true)}>
                        Realizar Nueva Postulación
                      </button>
                    </div>
                  ) : (
                    <div className="col align-self-center">
                      <h5 className="mg-b-2 tx-spacing--1 mt-3">
                        {postulante.nombres} {postulante.paterno} {postulante.materno}
                      </h5>
                      <h6 className="">
                        <span className="tx-color-03 m-0">Carrera/Programa: </span>
                        {postulante.programa}
                      </h6>
                      <h6 className=" mg-b-0">{postulante.tipo_admision}</h6>
                      <p className=" mg-b-0 mt-2 tx-color-03">
                        Esta postulación vence el <span className=" text-danger ">{fechaVencimientoPostulacion(postulante)}</span>
                      </p>
                    </div>
                  )}
                  <div className="col-sm-12 mg-t-20 mg-sm-t-0 mg-lg-t-25">
                    {registrarNuevo ? (
                      <></>
                    ) : (
                      <div>
                        <label className="tx-sans tx-10 tx-semibold tx-uppercase tx-color-01 tx-spacing-1 mg-b-15">Datos de generales</label>
                        <Row>
                          <Col>
                            <ul className="list-unstyled profile-info-list">
                              <li>
                                <LiaBirthdayCakeSolid className="h3 m-0" /> <span className="tx-color-03">{postulante.fec_nacimiento}</span>
                                <p className="tx-color-03" style={{ fontSize: "9px" }}>
                                  Fecha de Nacimiento
                                </p>
                              </li>
                              <li>
                                <FaTreeCity className="h3 m-0" />{" "}
                                <span className="tx-color-03">
                                  {postulante.localidad}, {postulante.provincia}, {postulante.departamento}-{postulante.pais}
                                </span>
                                <p className="tx-color-03" style={{ fontSize: "9px" }}>
                                  Lugar de nacimiento
                                </p>
                              </li>
                              <li>
                                <FaMapMarkedAlt className="h3 m-0" /> <span className="tx-color-03">{postulante.nacionalidad}</span>
                                <p className="tx-color-03" style={{ fontSize: "9px" }}>
                                  Nacionalidad
                                </p>
                              </li>
                            </ul>
                          </Col>

                          <Col>
                            <ul className="list-unstyled profile-info-list">
                              <li>
                                <FaRegIdCard className="h3 m-0" /> <span className="tx-color-03">{postulante.dip}</span>
                                <p className="tx-color-03" style={{ fontSize: "9px" }}>
                                  Número de documento
                                </p>
                              </li>
                              <li>
                                <IoMaleFemaleSharp className="h3 m-0" /> <span className="tx-color-03">{postulante.tipo_sexo}</span>
                                <p className="tx-color-03" style={{ fontSize: "9px" }}>
                                  Sexo
                                </p>
                              </li>
                              <li>
                                <FaUserTag className="h3 m-0" /> <span className="tx-color-03">{postulante.tipo_estado_civil}</span>
                                <p className="tx-color-03" style={{ fontSize: "9px" }}>
                                  Estado civil
                                </p>
                              </li>
                            </ul>
                          </Col>

                          <Col>
                            <ul className="list-unstyled profile-info-list">
                              <li>
                                <FaHome className="h3 m-0" /> <span className="tx-color-03">{postulante.direccion}</span>
                                <p className="tx-color-03" style={{ fontSize: "9px" }}>
                                  Dirección de domicilio
                                </p>
                              </li>
                              <li>
                                <MdOutlinePhoneIphone className="h3 m-0" /> <span className="tx-color-03">{postulante.celular}</span>
                                <p className="tx-color-03" style={{ fontSize: "9px" }}>
                                  Número de celular
                                </p>
                              </li>
                              <li>
                                <MdEmail className="h3 m-0" /> <span className="tx-color-03">{postulante.correo}</span>
                                <p className="tx-color-03" style={{ fontSize: "9px" }}>
                                  Correo electrónico
                                </p>
                              </li>
                            </ul>
                          </Col>
                        </Row>

                        <label className="tx-sans tx-10 tx-semibold tx-uppercase tx-color-01 tx-spacing-1 mg-b-15">Datos de académicos</label>
                        <Row>
                          <Col>
                            <ul className="list-unstyled profile-info-list">
                              <li>
                                <FaSchoolFlag className="h3 m-0" /> <span className="tx-color-03">{postulante.colegio}</span>
                                <p className="tx-color-03" style={{ fontSize: "9px" }}>
                                  Colegio / Unidad Educativa
                                </p>
                              </li>
                              <li>
                                <FaSchoolCircleExclamation className="h3 m-0" /> <span className="tx-color-03">{postulante.tipo_institucion}</span>
                                <p className="tx-color-03" style={{ fontSize: "9px" }}>
                                  Tipo Unidad Educativa
                                </p>
                              </li>
                            </ul>
                          </Col>

                          <Col>
                            <ul className="list-unstyled profile-info-list">
                              <li>
                                <IoSchool className="h3 m-0" /> <span className="tx-color-03">{postulante.anio_egreso}</span>
                                <p className="tx-color-03" style={{ fontSize: "9px" }}>
                                  Año de egreso
                                </p>
                              </li>
                              <li>
                                <MdSchedule className="h3 m-0" /> <span className="tx-color-03">{postulante.tipo_turno}</span>
                                <p className="tx-color-03" style={{ fontSize: "9px" }}>
                                  Turno de unidad educativa
                                </p>
                              </li>
                            </ul>
                          </Col>

                          <Col></Col>
                        </Row>

                        {postulante.enProceso ? (
                          <div className="mb-3 px-3">
                            <div className="alert alert-warning" role="alert">
                              Tramite en proceso de validación de pago...
                            </div>
                          </div>
                        ) : (
                          <></>
                        )}
                        <div className="d-flex mg-b-25">
                          {!postulante.enProceso ? (
                            <button className="btn btn-xs btn-warning flex-fill p-3" onClick={() => setViewModalNuevo(true)}>
                              <FaRegNewspaper className="me-1" />
                              Realizar Nueva Postulación
                            </button>
                          ) : (
                            <></>
                          )}
                          <button className="btn btn-xs btn-white flex-fill p-3 mg-l-10" onClick={() => descargarPdf()} disabled={descargandoPdf}>
                            {descargandoPdf ? <Spinner animation="border" size="sm" className="me-1" /> : <FaRegFilePdf className="me-1 text-danger" />}
                            {descargandoPdf ? "Generando formulario..." : "Descargar Formulario"}
                          </button>
                          {!postulante.enProceso ? (
                            <button className="btn btn-xs btn-primary flex-fill p-3 mg-l-10" onClick={() => setViewModalAddAdjunto(true)}>
                              <LiaMoneyBillWaveSolid className="me-1" />
                              Pagar y Confirmar Postulación
                            </button>
                          ) : (
                            <></>
                          )}
                        </div>
                      </div>
                    )}
                    <p className="tx-13 tx-color-02 mg-b-25">
                      Las Postulaciones son validas durante 7 días después de registrarlo, si los datos de postulación mostrados no son correctos,
                      puede realizar una nueva postulación ... <Link>Leer más</Link>
                    </p>
                  </div>
                </div>
              </div>
            </Col>
            <Col sm={12}>
              <hr />
              <div className="h5">Carreras habilitadas para postulación</div>
              <div className="row row-xs mg-b-25">
                {carrerasHabilitadas.map((d, i) => (
                  <div key={i} className="col-sm-4 col-md-3 col-lg-3 col-xl-2  mg-t-10 ">
                    <div className="card card-profile">
                      {/*<img
                        src="../../assets/img/img26.jpg"
                        className="card-img-top"
                        alt=""
                />*/}
                      <div className="card-body tx-13">
                        <div className="text-center m-0">
                          <h5 className="text-primary">{d.carrera}</h5>
                          <p>{d.facultad}</p>
                          <div className="text-start">
                            {d?.admisiones.slice(0, 2).map((dd, ii) => (
                              <div key={ii} className="mb-2 " style={{ fontSize: "11px" }}>
                                <FaCheckCircle className="text-success" /> {dd.tipo_admision}
                              </div>
                            ))}
                          </div>
                          <div className="mt-2">
                            {d?.admisiones.length > 2 ? (
                              <button
                                className="btn btn-sm btn-outline-primary  text-sm"
                                onClick={() => setViewModalCarrera({ show: true, data: d })}
                              >
                                Ver {d?.admisiones.length - 2} más
                              </button>
                            ) : (
                              <></>
                            )}
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                ))}
              </div>
            </Col>
            <MisCarrerasEstudiante />
          </Row>
        </Container>
      </div>

      <ModalAddAdjuntoPostulacion
        show={viewModalAddAjunto}
        onHide={() => setViewModalAddAdjunto(false)}
        postulante={postulante}
        onSuccess={() => loadIniciados()}
      />
      <ModalNuevaPostulacion
        show={viewModalNuevo}
        onHide={() => setViewModalNuevo(false)}
        postulante={postulante}
        onSuccess={() => loadIniciados()}
      />
      <ModalViewCarreraPostulacion
        show={viewModalCarrera.show ?? false}
        onHide={() => setViewModalCarrera({ show: false, data: {} })}
        data={viewModalCarrera.data ?? {}}
      />
    </>
  );
};

export default Postulacion;

const ModalAddAdjuntoPostulacion = ({ show, onHide, postulante, onSuccess }) => {
  const { setSpinnerLoad } = useUsuario();

  const [positionStep, setPositionStep] = useState(0);

  const [selectedFileCN, setSelectedFileCN] = useState(null);
  const [selectedFileCI, setSelectedFileCI] = useState(null);
  const [selectedFileTB, setSelectedFileTB] = useState(null);
  const [selectedFoto, setSelectedFoto] = useState(null);

  const [codeTransfer, setCodeTransfer] = useState(null);
  const [monto, setMonto] = useState(null);
  const [generandoQr, setGenerandoQr] = useState(false);
  const [transaccionQr, setTransaccionQr] = useState(null);

  const cargarAdjunto = () => {
    let formData = new FormData();
    formData.append("fileCN", selectedFileCN);
    formData.append("fileCI", selectedFileCI);
    formData.append("fileTB", selectedFileTB);
    formData.append("fileFO", selectedFoto);
    formData.append("code", codeTransfer);
    formData.append("monto", monto);
    if (transaccionQr?.codigoTransaccion || transaccionQr?.idTransaccion) {
      formData.append("codigoTransaccion", transaccionQr.codigoTransaccion ?? transaccionQr.idTransaccion);
    }

    setSpinnerLoad(true);
    httpPostMultiPart(formData, "/api/v1/postulante/adjuntarPago").then((d) => {
      setSpinnerLoad(false);
      if (d) {
        onSuccess();
        onHide();
      }
    });
  };

  const generarPagoQr = () => {
    setGenerandoQr(true);
    httpPost({}, "/api/v1/postulante/pago/generar")
      .then((d) => {
        if (d) {
          setTransaccionQr(d);
          setCodeTransfer(d.codigoTransaccion ?? d.idTransaccion ?? "");
          setMonto(d.montoTotal ?? postulante?.costoAdmision ?? "");
          if (d.urlRedireccion) {
            window.open(d.urlRedireccion, "_blank");
          }
          toast.success("Transacción QR generada. Complete el pago en la pasarela.");
        }
      })
      .finally(() => setGenerandoQr(false));
  };

  useEffect(() => {
    if (!show) {
      setPositionStep(0);
    }
  }, [show]);

  const seccionIni = (visible) => {
    return (
      <div className={`p-3 ${!visible ? "d-none" : ""}`}>
        <h5 className="tx-18 tx-sm-20 mg-b-20">Pago y Adjunto de Recibo</h5>
        <p>Para proceder con el registro de su postuación, debes contar con los siguientes requisitos.</p>
        <div className="ms-3">
          <div className="mb-2 ">
            <IoCheckmarkCircleOutline className="text-primary" /> Certificado de Nacimiento escaneado en formato PDF
          </div>{" "}
          <div className="mb-2 ">
            <IoCheckmarkCircleOutline className="text-primary" /> Cédula de identidad escaneado en formato PDF
          </div>{" "}
          <div className="mb-2 ">
            <IoCheckmarkCircleOutline className="text-primary" /> Título de Bachiller o Certificado de último año de secundaria en formato PDF
          </div>
          <div className="mb-2 ">
            <IoCheckmarkCircleOutline className="text-primary" /> Foto en tipo carnet en formato JPG
          </div>
          <div className="mb-2 ">
            <IoCheckmarkCircleOutline className="text-primary" /> Pago por QR en la pasarela de pagos.{" "}
            <a data-bs-toggle="collapse" href={"#collapDetallInfo"} role="button" aria-expanded="false" aria-controls="collapseExample">
              Ver monto
            </a>
            <div className="collapse mt-1 ms-2" id={"collapDetallInfo"}>
              <div className="">
                <div className="divider-text mb-3 text-center">Pago por QR</div>
                <ul>
                  <li>
                    <p className="">
                      <strong>
                        Se generará una transacción QR por<span className="fs-5"> {postulante.costoAdmision} Bs</span>.
                      </strong>
                    </p>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>
        <Col sm={12} className="text-center mt-3">
          <button className="btn btn-outline-light m-1 " onClick={() => onHide()}>
            Cancelar
          </button>
          <button className="btn btn-primary m-1 " onClick={() => setPositionStep(1)}>
            Continuar
          </button>
        </Col>
      </div>
    );
  };

  const certNacimiento = (visible) => {
    return (
      <div className={`${!visible ? "d-none" : ""}`}>
        <div className="d-flex">
          <div className="m-auto" style={{ maxWidth: "500px" }}>
            <PDFDropzone id={1} tipoDoc={"Certificado de Nacimiento"} doc={selectedFileCN} onSelect={(d) => setSelectedFileCN(d)} />
          </div>
        </div>
        <Col sm={12} className="text-center my-3">
          <button className="btn btn-outline-light m-1" onClick={() => onHide()}>
            Cancelar
          </button>
          <button className="btn btn-outline-light m-1" onClick={() => setPositionStep(positionStep - 1)}>
            Atrás
          </button>

          {selectedFileCN ? (
            <button className="btn btn-primary m-1" onClick={() => setPositionStep(positionStep + 1)}>
              Continuar
            </button>
          ) : (
            <></>
          )}
        </Col>
      </div>
    );
  };

  const cedIdentidad = (visible) => {
    return (
      <div className={`${!visible ? "d-none" : ""}`}>
        <div className="d-flex">
          <div className="m-auto" style={{ maxWidth: "500px" }}>
            <PDFDropzone id={2} tipoDoc={"Cedula de Identidad"} doc={selectedFileCI} onSelect={(d) => setSelectedFileCI(d)} />
          </div>
        </div>
        <Col sm={12} className="text-center my-3">
          <button className="btn btn-outline-light m-1" onClick={() => onHide()}>
            Cancelar
          </button>
          <button className="btn btn-outline-light m-1" onClick={() => setPositionStep(positionStep - 1)}>
            Atrás
          </button>
          {selectedFileCI ? (
            <button className="btn btn-primary m-1" onClick={() => setPositionStep(positionStep + 1)}>
              Continuar
            </button>
          ) : (
            <></>
          )}
        </Col>
      </div>
    );
  };

  const titBachiller = (visible) => {
    return (
      <div className={`${!visible ? "d-none" : ""}`}>
        <div className="d-flex">
          <div className="m-auto" style={{ maxWidth: "500px" }}>
            <PDFDropzone
              id={3}
              tipoDoc={"Título de Bachiller o Certificado de último año de secundaria"}
              doc={selectedFileTB}
              onSelect={(d) => setSelectedFileTB(d)}
            />
          </div>
        </div>
        <Col sm={12} className="text-center my-3">
          <button className="btn btn-outline-light m-1" onClick={() => onHide()}>
            Cancelar
          </button>
          <button className="btn btn-outline-light m-1" onClick={() => setPositionStep(positionStep - 1)}>
            Atrás
          </button>
          {selectedFileTB ? (
            <button className="btn btn-primary m-1" onClick={() => setPositionStep(positionStep + 1)}>
              Continuar
            </button>
          ) : (
            <></>
          )}
        </Col>
      </div>
    );
  };

  const fotoUsuario = (visible) => {
    return (
      <div className={`${!visible ? "d-none" : ""}`}>
        <div className="d-flex">
          <div className="m-auto" style={{ maxWidth: "500px" }}>
            <IMAGEDropzoneSqrt
              id={4}
              tipoDoc={"Foto"}
              imagenC={selectedFoto}
              onSelect={(d) => setSelectedFoto(d)}
              onDelete={() => setSelectedFoto(null)}
            />
          </div>
        </div>
        <Col sm={12} className="text-center my-3">
          <button className="btn btn-outline-light m-1" onClick={() => onHide()}>
            Cancelar
          </button>
          <button className="btn btn-outline-light m-1" onClick={() => setPositionStep(positionStep - 1)}>
            Atrás
          </button>
          {selectedFoto ? (
            <button className="btn btn-primary m-1" onClick={() => setPositionStep(positionStep + 1)}>
              Continuar
            </button>
          ) : (
            <></>
          )}
        </Col>
      </div>
    );
  };

  const pagoQr = (visible) => {
    return (
      <div className={`m-3 ${!visible ? "d-none" : ""}`}>
        <div>
          <div className="divider-text mb-3 text-center">Pago por QR</div>
          <div className="alert alert-info">
            Se generará una transacción QR por <strong>{postulante?.costoAdmision ?? 0} Bs</strong> para confirmar su postulación.
          </div>
        </div>

        <div>
          <div className="divider-text pb-1 text-center pt-3">Pasarela de pagos</div>

          <div>
            <Row>
              <Col sm={12}>
                <div className="bd rounded-3 p-3 bg-gray-50">
                  <div className="d-sm-flex align-items-center">
                    <div>
                      <p className="fw-bold mb-1">{transaccionQr ? "Transacción QR generada" : "Genere el pago QR para continuar"}</p>
                      <p className="text-muted mb-0">
                        {transaccionQr
                          ? `Código de transacción: ${transaccionQr.codigoTransaccion ?? transaccionQr.idTransaccion}`
                          : "La pasarela se abrirá en una nueva pestaña."}
                      </p>
                    </div>
                    <div className="ms-sm-auto mt-3 mt-sm-0">
                      <button className="btn btn-primary" onClick={generarPagoQr} disabled={generandoQr}>
                        {generandoQr ? <Spinner animation="border" size="sm" className="me-1" /> : <FaMoneyBillWave className="me-1" />}
                        {transaccionQr ? "Generar nuevo QR" : "Generar Pago QR"}
                      </button>
                    </div>
                  </div>
                </div>
              </Col>

              <Col sm={12} className="text-center">
                <button className="btn btn-outline-light m-1" onClick={() => onHide()}>
                  Cancelar
                </button>
                <button className="btn btn-outline-light m-1" onClick={() => setPositionStep(positionStep - 1)}>
                  Atrás
                </button>
                {transaccionQr ? (
                  <button className="btn btn-primary m-1" onClick={() => setPositionStep(positionStep + 1)}>
                    Continuar
                  </button>
                ) : (
                  <></>
                )}
              </Col>
            </Row>
          </div>
        </div>
      </div>
    );
  };

  const confirmarDatos = (visible) => {
    return (
      <div className={`m-3 ${!visible ? "d-none" : ""}`}>
        <div className="h5 mb-4">Datos Obtenidos</div>
        <div className="my-1 d-flex">
          <div>
            <p className="fw-bold mb-0">{selectedFileCN?.name ?? ""}</p>
            <p className="text-muted" style={{ fontSize: "11px" }}>
              Certificado de Nacimiento escaneado en formato PDF
            </p>
          </div>
          <div className="ms-auto px-1">
            <FaCheckCircle className="text-success h4" />
          </div>
        </div>
        <div className="my-1 d-flex">
          <div>
            <p className="fw-bold mb-0">{selectedFileCI?.name ?? ""}</p>
            <p className="text-muted" style={{ fontSize: "11px" }}>
              Cédula de identidad escaneado en formato PDF
            </p>
          </div>
          <div className="ms-auto px-1">
            <FaCheckCircle className="text-success h4" />
          </div>
        </div>
        <div className="my-1 d-flex">
          <div>
            <p className="fw-bold mb-0">{selectedFileTB?.name ?? ""}</p>
            <p className="text-muted" style={{ fontSize: "11px" }}>
              Título de Bachiller o Certificado de último año de secundaria en formato PDF
            </p>
          </div>
          <div className="ms-auto px-1">
            <FaCheckCircle className="text-success h4" />
          </div>
        </div>
        <div className="my-1 d-flex">
          <div>
            <p className="fw-bold mb-0">{selectedFoto?.name ?? ""}</p>
            <p className="text-muted" style={{ fontSize: "11px" }}>
              Foto en tipo carnet en formato JPG
            </p>
          </div>
          <div className="ms-auto px-1">
            <FaCheckCircle className="text-success h4" />
          </div>
        </div>
        <div className="divider-text  text-center m-0 mb-3">Pago QR</div>
        <div className="my-1 d-flex">
          <div>
            <p className="fw-bold mb-0">{codeTransfer}</p>
            <p className="text-muted" style={{ fontSize: "11px" }}>
              Código de transacción
            </p>
          </div>
          <div className="ms-auto px-1">
            <FaCheckCircle className="text-success h4" />
          </div>
        </div>
        <div className="my-1 d-flex">
          <div>
            <p className="fw-bold mb-0">{monto}</p>
            <p className="text-muted" style={{ fontSize: "11px" }}>
              Monto del QR
            </p>
          </div>
          <div className="ms-auto px-1">
            <FaCheckCircle className="text-success h4" />
          </div>
        </div>

        <Col sm={12} className="text-center mt-3">
          <button className="btn btn-outline-light m-1" onClick={() => onHide()}>
            Cancelar
          </button>
          <button className="btn btn-outline-light m-1" onClick={() => setPositionStep(positionStep - 1)}>
            Atrás
          </button>
          <button className="btn btn-success m-1" onClick={() => cargarAdjunto()}>
            Registrar datos
          </button>
        </Col>
      </div>
    );
  };

  return (
    <Modal show={show} size={"xl"} onHide={onHide} centered={true} backdrop={"static"} keyboard={false}>
      <Modal.Body className="tx-13  p-0">
        <span className="close pos-absolute t-20 r-20 text-secondary pointer" onClick={onHide}>
          <MdClose />
        </span>
        {postulacionPuedeAdjuntar(postulante) ? (
          <>
            {positionStep > 0 && positionStep < 6 ? (
              <>
                <div className="mb-2">
                  <ul className="steps steps-tab steps-sm steps-justified">
                    <li className={`step-item ${positionStep === 1 ? "active" : positionStep > 1 ? "complete" : "disabled"}`}>
                      <Link className={"step-link"}>
                        <span className="step-icon m-auto m-lg-0">
                          <BsFillFilePersonFill />
                        </span>
                        <span className="step-title d-none d-lg-block">Certificado de Nacimiento</span>
                      </Link>
                    </li>
                    <li className={`step-item ${positionStep === 2 ? "active" : positionStep > 2 ? "complete" : "disabled"}`}>
                      <Link className={"step-link"}>
                        <span className="step-icon m-auto m-lg-0">
                          <BsFillPersonVcardFill />
                        </span>
                        <span className="step-title d-none d-lg-block">Cédula de Identidad</span>
                      </Link>
                    </li>
                    <li className={`step-item ${positionStep === 3 ? "active" : positionStep > 3 ? "complete" : "disabled"}`}>
                      <Link className={"step-link"}>
                        <span className="step-icon m-auto m-lg-0">
                          <IoIosSchool />
                        </span>
                        <span className="step-title d-none d-lg-block">Título de Bachiller</span>
                      </Link>
                    </li>
                    <li className={`step-item ${positionStep === 4 ? "active" : positionStep > 4 ? "complete" : "disabled"}`}>
                      <Link className={"step-link"}>
                        <span className="step-icon m-auto m-lg-0">
                          <BsPersonBoundingBox />
                        </span>
                        <span className="step-title d-none d-lg-block">Foto</span>
                      </Link>
                    </li>
                    <li className={`step-item ${positionStep === 5 ? "active" : positionStep > 5 ? "complete" : "disabled"}`}>
                      <Link className={"step-link"}>
                        <span className="step-icon m-auto m-lg-0">
                          <FaMoneyBillWave />
                        </span>
                          <span className="step-title d-none d-lg-block">Pago QR</span>
                      </Link>
                    </li>
                  </ul>
                </div>
                <div className="m-3">
                  <p className="text-danger">** Realiza cuidadosamente este paso y verifica que la información registrada es correcta</p>
                </div>
              </>
            ) : (
              <></>
            )}
            {seccionIni(positionStep === 0)}
            {certNacimiento(positionStep === 1)}
            {cedIdentidad(positionStep === 2)}
            {titBachiller(positionStep === 3)}
            {fotoUsuario(positionStep === 4)}
            {pagoQr(positionStep === 5)}
            {confirmarDatos(positionStep === 6)}
          </>
        ) : (
          <div className="p-3">
            <h5 className="tx-18 tx-sm-20 mg-b-20">Pago y Adjunto de Recibo</h5>
            <div className="alert alert-warning">{mensajeNoAdjuntable(postulante)}</div>
          </div>
        )}
      </Modal.Body>
    </Modal>
  );
};

const ModalNuevaPostulacion = (props) => {
  const { setSpinnerLoad } = useUsuario();
  const [isLoad, setIsLoad] = useState(false);
  const [positionStep, setPositionStep] = useState(1);
  const [dataPersona, setDataPersona] = useState({});
  const [datosNuevaPostulacion, setDatosNuevaPostulacion] = useState({});

  useEffect(() => {
    const loadDataPersonal = () => {
      setIsLoad(true);
      httpGet("/api/v1/postulante/buscarDatosPersonaCi").then((d) => {
        console.log(d);
        if (d) {
          setDataPersona(d);
        }
        setIsLoad(false);
      });
    };

    if (props.show) {
      loadDataPersonal();
    }
  }, [props.show]);

  useEffect(() => {
    if (props.show) {
      setDatosNuevaPostulacion({});
      setPositionStep(1);
    }
  }, [props.show]);

  const next = () => {
    setPositionStep(positionStep + 1);
  };

  const prev = () => {
    setPositionStep(positionStep - 1);
  };

  const crearNuevaPostulacion = (d) => {
    setSpinnerLoad(true);
    let data = Object.assign({}, datosNuevaPostulacion, d);
    httpPost(data, "/api/v1/postulante/nuevaPostulacion").then((d) => {
      if (d) {
        props.onSuccess();
      }
      setSpinnerLoad(false);
    });
  };

  return (
    <Modal show={props.show} size={"lg"} onHide={props.onHide} centered={true} backdrop={"static"} keyboard={false}>
      <Modal.Body className="tx-13 p-0">
        <span className="close pos-absolute t-20 r-20 text-secondary pointer" data-bs-dismiss="modal" aria-label="Close"></span>
        <div className="mb-2">
          <ul className="steps steps-tab steps-sm steps-justified">
            <li className={`step-item ${positionStep === 1 ? "active" : positionStep > 1 ? "complete" : "disabled"}`}>
              <Link className={"step-link"}>
                <span className="step-icon">
                  <LuUser />
                </span>
                <span className="step-title">Información Personal</span>
              </Link>
            </li>
            <li className={`step-item ${positionStep === 2 ? "active" : positionStep > 2 ? "complete" : "disabled"}`}>
              <Link className={"step-link"}>
                <span className="step-icon">
                  <RiContactsLine />
                </span>
                <span className="step-title">Datos Generales</span>
              </Link>
            </li>
            <li className={`step-item ${positionStep === 3 ? "active" : positionStep > 3 ? "complete" : "disabled"}`}>
              <Link className={"step-link"}>
                <span className="step-icon">
                  <FaUniversity />
                </span>
                <span className="step-title">Datos de Postulación</span>
              </Link>
            </li>
          </ul>
        </div>

        {isLoad ? (
          <div className="my-5 py-5 text-center">
            <Spinner animation="border" role="status">
              <span className="visually-hidden">Cargando...</span>
            </Spinner>
          </div>
        ) : (
          <div className="p-3">
            <InformacionPersonalForm
              oculto={positionStep !== 1}
              cancelar={() => props.onHide()}
              prev={() => prev()}
              next={() => next()}
              persona={dataPersona}
              onSuccess={(d) => {
                setDatosNuevaPostulacion(Object.assign({}, datosNuevaPostulacion, d));
              }}
            />
            <DatosGeneralesForm
              oculto={positionStep !== 2}
              cancelar={() => props.onHide()}
              prev={() => prev()}
              next={() => next()}
              persona={dataPersona}
              postulante={props.postulante}
              onSuccess={(d) => {
                setDatosNuevaPostulacion(Object.assign({}, datosNuevaPostulacion, d));
              }}
            />
            <DatosPostulacionForm
              oculto={positionStep !== 3}
              cancelar={() => props.onHide()}
              prev={() => prev()}
              next={() => next()}
              onSuccess={(d) => crearNuevaPostulacion(d)}
            />
          </div>
        )}
        <br />
      </Modal.Body>
    </Modal>
  );
};

const InformacionPersonalForm = (props) => {
  const [expedidos, setExpedidos] = useState([]);
  const [sexos, setSexos] = useState([]);
  const [tipoEstadosCivil, setTipoEstadosCivil] = useState([]);

  const [formNombres, setFormNombres] = useState("");
  const [formPaterno, setFormPaterno] = useState("");
  const [formMaterno, setFormMaterno] = useState("");
  const [formCi, setFormCi] = useState("");
  const [formIdExpedido, setFormIdExpedido] = useState(0);
  const [formFecNacimiento, setFormFecNacimiento] = useState("");
  const [formIdSexo, setFormIdSexo] = useState(0);
  const [formIdCivil, setFormIdCivil] = useState(0);
  const [formCelular, setFormCelular] = useState("");
  const [codigoPais, setCodigoPais] = useState("591");
  const [formCorreo, setFormCorreo] = useState("");
  const [formDireccion, setFormDireccion] = useState("");

  useEffect(() => {
    loadExpedidos();
    loadSexos();
    loadEstadosCiviles();
  }, []);

  useEffect(() => {
    const loadDataPersonal = () => {
      let d = props.persona;
      if (d) {
        setFormNombres(d.nombres);
        setFormPaterno(d.paterno);
        setFormMaterno(d.materno);
        setFormCi(d.ci);
        setFormIdExpedido(d.code_expedido);
        setFormFecNacimiento(d.fecha_nacimiento);
        setFormIdSexo(d.code_sexo);
        setFormIdCivil(d.code_civil);
        //verificarCodigo
        var cod = identificarCodigoPais(d.celular ?? "");
        if (cod.tieneCodigoPais ?? false) {
          setCodigoPais(cod.codigo);
        }
        setFormCelular(cod.numeroLocal);
        setFormCorreo(d.email);
        setFormDireccion(d.direccion);
      }
    };

    loadDataPersonal();
  }, [props.persona]);

  const loadExpedidos = () => {
    httpGet("/api/v1/general/expedidos").then((d) => {
      console.log(d);
      if (d) {
        setExpedidos(d);
      }
    });
  };
  const loadSexos = () => {
    httpGet("/api/v1/general/sexos").then((d) => {
      console.log(d);
      if (d) {
        setSexos(d);
      }
    });
  };

  const continuarProceso = () => {
    if (
      !(
        formNombres &&
        formPaterno &&
        formMaterno &&
        formCi &&
        formIdExpedido &&
        formFecNacimiento &&
        formIdSexo &&
        formIdCivil &&
        formCelular &&
        formCorreo &&
        formDireccion
      )
    ) {
      toast.error("Debe llenar todos los datos del formulario");
      return;
    }
    let data = {
      nombres: formNombres,
      paterno: formPaterno,
      materno: formMaterno,
      ci: formCi,
      expedido: formIdExpedido,
      fec_nacimiento: formFecNacimiento,
      sexo: formIdSexo,
      civil: formIdCivil,
      celular: codigoPais + formCelular,
      correo: formCorreo,
      direccion: formDireccion,
    };
    props.onSuccess(data);
    props.next();
  };

  const loadEstadosCiviles = () => {
    httpGet("/api/v1/general/estados_civiles").then((d) => {
      console.log(d);
      if (d) {
        setTipoEstadosCivil(d);
      }
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    continuarProceso();
  };

  return (
    <>
      <div className={`step-2 ${props.oculto ? "d-none" : ""}`}>
        <form onSubmit={handleSubmit}>
          <div className="h5 tx-color-03 mb-3 text-center">Revisa y Confirma la información encontrada</div>
          <Row>
            <Col sm={12} lg={6} md={6} className="form-group">
              <label className="form-label tx-color-03">Nombres</label>
              <input
                type="text"
                className="form-control"
                placeholder="Nombres"
                value={formNombres}
                onChange={(e) => setFormNombres(e.target.value)}
                required
              />
            </Col>
            <Col sm={12} lg={3} md={6} className="form-group">
              <label className="form-label tx-color-03">Primer Apellido</label>
              <input
                type="text"
                className="form-control"
                placeholder="Primer Apellido"
                value={formPaterno}
                onChange={(e) => setFormPaterno(e.target.value)}
                required
              />
            </Col>
            <Col sm={12} lg={3} md={6} className="form-group">
              <label className="form-label tx-color-03">Segundo Apellido</label>
              <input
                type="text"
                className="form-control"
                placeholder="Segundo Apellido"
                value={formMaterno}
                onChange={(e) => setFormMaterno(e.target.value)}
                required
              />
            </Col>
            <Col sm={12} lg={3} md={6} className="form-group">
              <label className="form-label tx-color-03">N° de Cédula de Identidad</label>
              <input type="text" className="form-control" disabled={true} value={formCi} required />
            </Col>
            <Col sm={12} lg={3} md={6} className="form-group">
              <label className="form-label tx-color-03">Expedido en</label>
              <select className="form-select" required={true} value={formIdExpedido} onChange={(e) => setFormIdExpedido(e.target.value)}>
                <option value={0}>Seleccione una Opción</option>
                {expedidos.map((d, i) => (
                  <option key={i} value={d.code}>
                    {d.descripcion}
                  </option>
                ))}
              </select>
            </Col>
            <Col sm={12} lg={3} md={6} className="form-group">
              <label className="form-label tx-color-03">Fecha de Nacimiento</label>
              <input
                type="date"
                className="form-control"
                placeholder="Fecha de nacimiento"
                value={formFecNacimiento}
                onChange={(e) => setFormFecNacimiento(e.target.value)}
                required
              />
            </Col>
            <Col sm={12} lg={3} md={6} className="form-group">
              <label className="form-label tx-color-03">Género</label>
              <select className="form-select" required={true} value={formIdSexo} onChange={(e) => setFormIdSexo(e.target.value)}>
                <option value={0}>Seleccione una Opción</option>
                {sexos.map((d, i) => (
                  <option key={i} value={d.code}>
                    {d.tipo_sexo}
                  </option>
                ))}
              </select>
            </Col>
            <Col sm={12} lg={3} md={6} className="form-group">
              <label className="form-label tx-color-03">Estado Civil</label>
              <select className="form-select" required={true} value={formIdCivil} onChange={(e) => setFormIdCivil(e.target.value)}>
                <option value={0}>Seleccione una Opción</option>
                {tipoEstadosCivil.map((d, i) => (
                  <option key={i} value={d.code}>
                    {d.tipo_estado_civil}
                  </option>
                ))}
              </select>
            </Col>
            <Col sm={12} lg={4} md={6} className="form-group">
              <label className="form-label tx-color-03">Número de Celular</label>
              <div className="d-flex">
                <select className="form-select me-2" value={codigoPais} onChange={(e) => setCodigoPais(e.target.value)} style={{ maxWidth: "90px" }}>
                  {paises.map((pais) => (
                    <option key={pais.codigo} value={pais.value}>
                      {`${pais.iso} ${pais.codigo}`}
                    </option>
                  ))}
                </select>

                <input
                  type="tel"
                  className="form-control"
                  placeholder="Número de celular"
                  value={formCelular}
                  onChange={(e) => setFormCelular(e.target.value)}
                  required
                />
              </div>
            </Col>
            <Col sm={12} lg={5} md={6} className="form-group">
              <label className="form-label tx-color-03">Correo electrónico</label>
              <input
                type="text"
                className="form-control"
                disabled={props.persona.email ?? false}
                value={formCorreo}
                onChange={(e) => setFormCorreo(e.target.value)}
              />
            </Col>
            <Col sm={12} lg={12} md={12} className="form-group">
              <label className="form-label tx-color-03">Dirección</label>
              <input
                type="text"
                className="form-control"
                placeholder="Dirección de Domicilio"
                value={formDireccion}
                onChange={(e) => setFormDireccion(e.target.value)}
                required
              />
            </Col>
          </Row>
          <div className="d-flex mt-3">
            <button className="btn btn-outline-light me-auto" type="button" onClick={() => props.cancelar()}>
              Cancelar
            </button>
            <button className="btn btn-primary ms-3" type="submit">
              Continuar
            </button>
          </div>
        </form>
      </div>
    </>
  );
};

const DatosGeneralesForm = (props) => {
  const [provincias, setProvincias] = useState([]);

  const [formIdLocalidad, setFormIdLocalidad] = useState("0");
  const [formIdNacionalidad, setFormIdNacionalidad] = useState("0");
  const [formUnidadEducativa, setFormUnidadEducativa] = useState("");
  const [formAnioEgreso, setFormAnioEgreso] = useState("");
  const [formIdTipoUE, setFormIdTipoUE] = useState("0");
  const [formIdTipoTurno, setFormIdTipoTurno] = useState("0");

  useEffect(() => {
    loadProvincias();
  }, []);

  const { postulante, persona } = props;
  const fetchPostulante = useCallback(() => {
    const d = persona ?? {};
    const dd = postulante ?? {};

    setFormIdLocalidad(primerValor(dd.id_localidad, d.code_localidad) ?? "0");
    setFormIdNacionalidad(primerValor(dd.id_nacionalidad, d.code_nacionalidad) ?? "0");
    setFormUnidadEducativa(primerValor(dd.colegio, d.unidad_educativa) ?? "");
    setFormAnioEgreso(primerValor(dd.anio_egreso, d.anio_egreso) ?? "");
    setFormIdTipoUE(primerValor(dd.id_tipo_institucion, d.code_tipo_ue) ?? "0");
    setFormIdTipoTurno(primerValor(dd.id_tipo_turno, d.code_tipo_turno) ?? "0");
  }, [postulante, persona]);

  useEffect(() => {
    fetchPostulante();
  }, [fetchPostulante]);

  const continuarProceso = () => {
    if (!(formIdLocalidad && formIdNacionalidad && formUnidadEducativa && formAnioEgreso && formIdTipoUE && formIdTipoTurno)) {
      toast.error("Debe llenar todos los datos del formulario");
      return;
    }
    let data = {
      localidad: formIdLocalidad,
      nacionalidad: formIdNacionalidad,
      unidad_educativa: formUnidadEducativa,
      anio_egreso: formAnioEgreso,
      tipo_ue: formIdTipoUE,
      tipo_turno: formIdTipoTurno,
    };
    props.onSuccess(data);
    props.next();
  };

  const loadProvincias = () => {
    httpGet("/api/v1/general/provincias_completo").then((d) => {
      console.log(d);
      if (d) {
        let l = [];
        d.forEach((e) => {
          l.push({ value: e["code"], label: e["ubicacion"] });
        });
        setProvincias(l);
      }
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    continuarProceso();
  };

  return (
    <div className={`step-2 ${props.oculto ? "d-none" : ""}`}>
      <form onSubmit={handleSubmit}>
        <div className="h5 tx-color-03 mb-3 text-center">Revisa y Confirma la información encontrada</div>
        <Row>
          <Col sm={12} className="form-group">
            <label className="form-label tx-color-03">Lugar de Nacimiento</label>
            <Select
              options={provincias}
              autoFocus={true}
              placeholder={"Seleccione el lugar de nacimiento"}
              value={provincias.filter((option) => option.value === formIdLocalidad)}
              onChange={(e) => setFormIdLocalidad(e.value)}
              required
            />
          </Col>
          <Col sm={12} lg={6} md={6} className="form-group">
            <label className="form-label tx-color-03">Nacionalidad</label>
            <select className="form-select" required value={formIdNacionalidad} onChange={(e) => setFormIdNacionalidad(e.target.value)}>
              <option value="0">Seleccione una Opción</option>
              <option value="1"> Boliviana</option>
              <option value="2"> Extranjera</option>
            </select>
          </Col>
          <Col sm={12} lg={6} md={6} className="form-group">
            <label className="form-label tx-color-03">Unidad Educativa</label>
            <input
              type="text"
              className="form-control"
              placeholder="Unidad Educativa"
              value={formUnidadEducativa}
              onChange={(e) => setFormUnidadEducativa(e.target.value)}
              required
            />
          </Col>
          <Col sm={12} lg={6} md={6} className="form-group">
            <label className="form-label tx-color-03">Año de Egreso</label>
            <input
              type="text"
              className="form-control"
              placeholder="Año de Egreso Bachiller"
              value={formAnioEgreso}
              onChange={(e) => setFormAnioEgreso(e.target.value)}
              required
            />
          </Col>
          <Col sm={12} lg={6} md={6} className="form-group">
            <label className="form-label tx-color-03">Tipo U.E.</label>
            <select className="form-select" required value={formIdTipoUE} onChange={(e) => setFormIdTipoUE(e.target.value)}>
              <option value="0">Seleccione una Opción</option>
              <option value="1"> Fiscal</option>
              <option value="2"> Particular</option>
            </select>
          </Col>
          <Col sm={12} lg={6} md={6} className="form-group">
            <label className="form-label tx-color-03">Turno</label>
            <select className="form-select" required value={formIdTipoTurno} onChange={(e) => setFormIdTipoTurno(e.target.value)}>
              <option value="0">Seleccione una Opción</option>
              <option value="1"> Mañana</option>
              <option value="2"> Tarde</option>
              <option value="3"> Noche</option>
            </select>
          </Col>
          <Col sm={12}>
            <hr />
          </Col>{" "}
          {/*<Col sm={12} lg={4} md={4} className="form-group">
          <label className="form-label tx-color-03">Turno</label>
          <select
            className="form-select"
            required={true}
            value={formIdTipoTurno}
            onChange={(e) => setFormIdTipoTurno(e.target.value)}
          >
            <option value={0}>Seleccione una Opción</option>
            <option value="1"> Mañana</option>
            <option value="2"> Tarde</option>
            <option value="3"> Noche</option>
          </select>
        </Col>*/}
        </Row>
        <div className="d-flex mt-3">
          <button className="btn btn-outline-light me-auto" type="button" onClick={() => props.cancelar()}>
            Cancelar
          </button>
          <button className="btn btn-outline-light" type="button" onClick={() => props.prev()}>
            Anterior
          </button>
          <button className="btn btn-primary ms-3" type="submit">
            Continuar
          </button>
        </div>
      </form>
    </div>
  );
};

const DatosPostulacionForm = (props) => {
  const [carreras, setCarreras] = useState([]);
  const [carrerasInscritas, setCarrerasInscritas] = useState([]);
  const [tiposAdmision, setTiposAdmision] = useState([]);

  const [formIdCarrera, setFormIdCarrera] = useState(0);
  const [formIdAdmision, setFormIdAdmision] = useState(0);

  useEffect(() => {
    loadFacultades();
    httpGet("/api/v1/postulante/mis_carreras").then((d) => {
      if (d) {
        setCarrerasInscritas(d.map((c) => String(c.id_programa)));
      }
    });
  }, []);

  const loadFacultades = () => {
    httpGet("/api/v1/general/carrera_completo").then((d) => {
      if (d) {
        let l = [];
        d.forEach((e) => {
          l.push({
            value: e["code"],
            label: `${e["carrera"]}`,
            detail: e["facultad"],
          });
        });
        setCarreras(l);
      }
    });
  };

  const loadTiposAdmision = (id) => {
    httpPost({ id }, "/api/v1/general/tipos_admision").then((d) => {
      if (d) {
        setTiposAdmision(d);
      }
    });
  };

  const selecCarrera = (d) => {
    if (carrerasInscritas.includes(String(d))) {
      toast.error("Ya se encuentra matriculado en la carrera seleccionada");
      return;
    }
    setFormIdCarrera(d);
    loadTiposAdmision(d);
    setFormIdAdmision(0);
  };

  const continuarProceso = () => {
    if (!(formIdCarrera && formIdAdmision)) {
      toast.error("Debe selecionar la información requerida en el formulario");
      return;
    }
    if (carrerasInscritas.includes(String(formIdCarrera))) {
      toast.error("Ya se encuentra matriculado en la carrera seleccionada");
      return;
    }
    let data = {
      carrera: formIdCarrera,
      admision: formIdAdmision,
    };
    props.onSuccess(data);
    //props.guardar();
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    continuarProceso();
  };

  const opcionesCarreras = carreras.map((c) => ({
    ...c,
    isDisabled: carrerasInscritas.includes(String(c.value)),
  }));

  const formatOptionLabel = ({ label, detail, isDisabled }, { context }) => (
    <div style={{ display: "flex", flexDirection: "column" }}>
      <div>
        {label}{" "}
        {isDisabled ? <span className="tx-11 text-danger fw-bold">(ya matriculado)</span> : <></>}
      </div>
      <div style={{ fontSize: "12px", color: "#666" }}>{detail}</div>
    </div>
  );

  return (
    <div className={`step-2 ${props.oculto ? "d-none" : ""}`}>
      <form onSubmit={handleSubmit}>
        <Row>
          <Col sm={12} className="form-group">
            <label className="form-label tx-color-03">Carrera</label>
            <Select
              options={opcionesCarreras}
              formatOptionLabel={formatOptionLabel}
              autoFocus={true}
              required
              placeholder={"Seleccione una carrera"}
              onChange={(e) => selecCarrera(e.value)}
            />
            {formIdCarrera && tiposAdmision.length === 0 ? (
              <p className="text-danger m-0">La Carrera seleccionada no tiene habilitada ningún tipo de admisión</p>
            ) : (
              <></>
            )}
          </Col>
          <Col sm={12} lg={6} md={6} className="form-group">
            <label className="form-label tx-color-03">Tipo Admisión</label>
            <select className="form-select" required={true} onChange={(e) => setFormIdAdmision(e.target.value)}>
              <option value="">Seleccione una Opción</option>
              {tiposAdmision.map((d, i) => (
                <option key={i} value={d.code}>
                  {d.tipo_admision}
                </option>
              ))}
            </select>
          </Col>
        </Row>
        <div className="d-flex mt-3">
          <button className="btn btn-outline-light me-auto" onClick={() => props.cancelar()}>
            Cancelar
          </button>
          <button className="btn btn-outline-light" onClick={() => props.prev()}>
            Anterior
          </button>
          {formIdCarrera && formIdAdmision ? (
            <button className="btn btn-success ms-3" type="submit">
              Registrar Mi Postulación
            </button>
          ) : (
            <></>
          )}
        </div>
      </form>
    </div>
  );
};

const PDFDropzone = ({ id, doc, onSelect }) => {
  const fileInputRef = useRef(null);

  const handleFileSelect = (event) => {
    const file = event.target.files[0];
    if (file && file.type === "application/pdf") {
      onSelect(file);
    }
  };

  const handleDrop = (event) => {
    event.preventDefault();
    const file = event.dataTransfer.files[0];
    if (file && file.type === "application/pdf") {
      onSelect(file);
    }
  };

  const handleDragOver = (event) => {
    event.preventDefault();
  };

  const handleRemoveFile = () => {
    onSelect(null);
    if (fileInputRef.current) {
      fileInputRef.current.value = "";
    }
  };

  return (
    <div className="container mt-3 mb-3">
      <label
        htmlFor={`pdf-upload-${id}`}
        className={`box-drag-drop w-100 p-4 text-center d-block ${!doc ? "border-secondary" : "border-primary"}`}
        onDrop={handleDrop}
        onDragOver={handleDragOver}
      >
        <input type="file" accept=".pdf" ref={fileInputRef} onChange={handleFileSelect} className="d-none" id={`pdf-upload-${id}`} />

        {!doc ? (
          <div>
            <i className="bi bi-cloud-upload fs-1 text-secondary mb-3 d-block"></i>
            <p className="text-muted mb-3">Arrastra y suelta tu PDF aquí o haz clic para seleccionar</p>
          </div>
        ) : (
          <div className="d-flex justify-content-between align-items-center">
            <div className="d-flex align-items-center">
              <i className="bi bi-file-earmark-pdf text-danger me-3 fs-4"></i>
              <span className="fw-semibold">{doc.name}</span>
            </div>
            <div className=" my-auto">
              <button onClick={handleRemoveFile} className="btn btn-sm px-1 py-0">
                <IoCloseCircleSharp className="text-danger" />
              </button>
            </div>
          </div>
        )}
        <div>{doc?.tipoDoc ?? ""}</div>
      </label>
    </div>
  );
};

const IMAGEDropzoneSqrt = ({ id, imagenC, onSelect, onDelete }) => {
  const [image, setImage] = useState(null);
  const cropperRef = useRef(null);

  const wrapperRef = useRef(null);
  const onDragEnter = () => wrapperRef.current.classList.add("dragover");
  const onDragLeave = () => wrapperRef.current.classList.remove("dragover");
  const onDrop = () => wrapperRef.current.classList.remove("dragover");
  /*
  useEffect(()=>{
      setImage(imagen);
  },[imagen])
*/
  // Maneja la carga de la imagen
  const handleImageUpload = (event) => {
    const file = event.target.files[0];
    if (file) {
      const reader = new FileReader();
      reader.onload = () => {
        setImage(reader.result);
      };
      reader.readAsDataURL(file);
    }
  };

  // Maneja el recorte de la imagen
  const handleCrop = () => {
    if (cropperRef.current) {
      const cropper = cropperRef.current.cropper;
      const croppedCanvas = cropper.getCroppedCanvas({
        fillColor: "transparent", // Evita el fondo negro
      });
      const dataUrl = croppedCanvas.toDataURL("image/png", 0.8);
      onSelect(dataURLToFile(dataUrl, "foto.png")); // Envíos
    }
  };

  const handleRemoveFile = () => {
    onDelete();
  };

  if (imagenC) {
    return (
      <>
        <div className="container mt-3 mb-3">
          <label className={`box-drag-drop w-100 p-4 text-center d-block border-primary`}>
            <img src={URL.createObjectURL(imagenC)} alt="Vista previa" className="img-fluid" />
            <div className="d-flex justify-content-between align-items-center mt-2">
              <div className="d-flex align-items-center">
                <i className="bi bi-file-earmark-pdf text-danger me-3 fs-4"></i>
                <span className="fw-semibold">{imagenC.name}</span>
              </div>
              <div className=" my-auto">
                <button onClick={handleRemoveFile} className="btn btn-sm px-1 py-0">
                  <IoCloseCircleSharp className="text-danger" />
                </button>
              </div>
            </div>
          </label>
        </div>
      </>
    );
  }

  return (
    <div className="py-0">
      {image ? (
        <>
          <div className="text-end">
            <Button onClick={handleCrop} className="rounded-pill m-1" variant="secondary" size="sm">
              <FaCut className="me-1" /> Recortar
            </Button>
            <Button onClick={() => setImage(null)} className="rounded-pill m-1" variant="secondary" size="sm">
              <FaTrashCan className="me-1" /> Eliminar imagen
            </Button>
          </div>
          <Cropper
            src={image}
            style={{ height: 400, width: "100%" }}
            initialAspectRatio={"1"}
            aspectRatio={"1"}
            guides={true}
            ref={cropperRef}
            background={false}
          />
        </>
      ) : (
        <>
          <div ref={wrapperRef} className="drop-file-input" onDragEnter={onDragEnter} onDragLeave={onDragLeave} onDrop={onDrop}>
            <div className="drop-file-input__label">
              <BsBoxSeamFill
                className="mb-3"
                style={{
                  fontSize: "50px",
                  color: "rgb(255, 236, 203) !important",
                }}
              />
              <p>Arrastra aquí tu foto tipo carnet (sin lentes ni gorra)</p>
              <p className="fw-normal">o dale click para seleccionar una foto de tu galería</p>
              <p className="fw-normal text-sm m">La imagen no debe superar los 3 Mb.</p>
            </div>
            <input
              type="file"
              onChange={handleImageUpload}
              accept="image/*"
              //onClick={() => selectFile()}
            />
          </div>
        </>
      )}
    </div>
  );
};

const ModalViewCarreraPostulacion = ({ show, onHide, data }) => {
  return (
    <Modal show={show} size={"md"} onHide={onHide} centered={true}>
      <Modal.Body className="tx-13">
        <div className="text-center m-0">
          <h5 className="text-primary">{data.carrera}</h5>
          <p>{data.facultad}</p>
          <div className="text-start">
            {(data?.admisiones ?? []).map((dd, ii) => (
              <div key={ii} className="mb-2 " style={{ fontSize: "11px" }}>
                <FaCheckCircle className="text-success" /> {dd.tipo_admision ?? ""}
              </div>
            ))}
          </div>
        </div>
      </Modal.Body>
    </Modal>
  );
};
